import _ from 'lodash';
import ResizeObserver from 'resize-observer-polyfill';
/** 创建 element event map 存储 */
let targetEventMap = new Map();
const ro = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const event = createEvent('my-resize');
    event.contentRect = entry.contentRect;
    targetEventMap.set(entry.target, event);
  }
  let timer;
  timer && clearTimeout(timer);
  timer = setTimeout(() => {
    [...targetEventMap.entries()].forEach(([k, v]) => {
      k.dispatchEvent(v);
      targetEventMap.delete(k);
    });
  }, 200);

});
function createEvent(name, bubbles = false, cancelable = false) {
  const event = document.createEvent('Event');
  event.initEvent(name, bubbles, cancelable);
  return event;
}

export default {
  bind(el, binding) {
    ro.observe(el);
    if (_.isFunction(binding.value)) el.addEventListener('my-resize', binding.value);
  },
  unbind(el, binding) { ro.unobserve(el) }
};



// const ob = (el, binding) => new ResizeObserver(entries => {
//   _.throttle(entries => {
//     const contentRect = entries[0].contentRect;
//     binding.value(contentRect);
//   }, 200);
// });
// export default {
//   bind(el, binding) {
//     ob(el, binding).observe(el);
//     const ro = new ResizeObserver(_.debounce(entries => {
//       const cr = entries[0].contentRect;
//       binding.value(cr);
//     }, 200));
//     ro.observe(el);
//   },
//   unbind(el, binding) {
//   }
// };
